import styled from "styled-components";
import { Button as BsButton } from "react-bootstrap";

export const Divider = styled.hr`
  border: 0;
  border-top: 1px solid #e0e0e0;
  margin: 16px 0;
  width: 100%;
  opacity: 1;
`;

export const AddLessonBar = styled(BsButton)`
  && {
    width: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    background: #a0d6ff;         
    color: #1f5ea8;              
    border: 2px dotted #6fb4ef;   
    border-radius: 8px;
    font-weight: 700;
  }
  &&:hover, &&:focus {
    background: #93cdfd;
    color: #1f5ea8;
    border-color: #5aa6ec;
  }
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .5rem;

  .title {
    font-weight: 700;
  }
`;

export const IconButtons = styled.div`
  display: flex; gap: 6px;
  button {
    border: none;
    background: #a0d6ff;
    color: #1469a9;
    width: 28px; height: 28px;
    border-radius: 4px;
    font-weight: 800;
    line-height: 1;
  }
  button:hover { background: #93cdfd; }
`;

export const SectionLabel = styled.div`
  font-weight: 700;
  color: #6b7280;
  margin: 8px 0;
`;

export const FilesList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 16px;
  color: #6b7280;
  font-size: .9rem;
  li { margin-bottom: 2px; }
`;